import { render, staticRenderFns } from "./ProjectPermissions.vue?vue&type=template&id=284220be"
import script from "./ProjectPermissions.vue?vue&type=script&lang=js"
export * from "./ProjectPermissions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports